import Heading from 'shopper/components/Heading';

import FlatLayout from 'components/Layout/FlatLayout';
import HeadWithNoIndexAndNoFollow from 'components/Seo/HeadWithNoIndexAndNoFollow';

import { withAuth } from 'lib/hofs';
import placeholder from 'lib/placeholder';

import DeleteButtonSection from './DeleteAccount/DeleteButtonSection';
import EmailAlertsSettings from './EmailAlertsSettings';
import NotificationSettings from './NotificationSettings';
import QuickSettings from './QuickSettings';

const GA_EVENT_CATEGORY = 'user_settings';

const UserSettings = () => (
  <>
    <FlatLayout.Margin>
      <FlatLayout.Body>
        <HeadWithNoIndexAndNoFollow
          description={placeholder('seo.userSettings.description')}
          title={placeholder('seo.userSettings.title')}
        />
        <Heading className="mb-6 lg:mb-8">
          {placeholder('titles.settings')}
        </Heading>
        <main className="flex flex-col gap-y-8">
          <QuickSettings
            className="md:mb-12"
            gaEventCategory={GA_EVENT_CATEGORY}
          />
          <EmailAlertsSettings />
          <NotificationSettings />
          <DeleteButtonSection gaEventCategory={GA_EVENT_CATEGORY} />
        </main>
      </FlatLayout.Body>
    </FlatLayout.Margin>
    <FlatLayout.Footer />
  </>
);

export default withAuth(UserSettings);
